import { apiAgent } from "../../config/axiosConfig";
import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  updateLoadError,
  setLoadingState,
  setSavingState,
} from "./dynamicVariableSlice";

export const createDynamicVariable = createAsyncThunk(
  "createDynamicVariable",
  async (
    { resourceId, resourceType, varName, varValueEvaluator },
    { dispatch, rejectWithValue }
  ) => {
    await dispatch(setLoadingState(true));
    try {
      const response = await apiAgent({
        method: "POST",
        url: "/api/v1/dynamic_variables",
        data: {
          var_name: varName,
          var_value_evaluator: varValueEvaluator,
          resource_type: resourceType,
          resource_id: resourceId,
        },
      });
      if (response.status === 200) {
        await dispatch(setLoadingState(false));
        return response?.data;
      } else {
        await dispatch(setLoadingState(false));
        return rejectWithValue(response.data);
      }
    } catch (err) {
      dispatch(updateLoadError({ error_message: err.response.data.message }));
    }
  }
);

export const updateDynamicVariable = createAsyncThunk(
  "updateDynamicVariable",
  async (
    { dynamicVariableValue, dynamicVariableId },
    { dispatch, rejectWithValue }
  ) => {
    await dispatch(setSavingState(true));
    try {
      const response = await apiAgent({
        method: "PUT",
        url: `/api/v1/dynamic_variables/${dynamicVariableId}`,
        data: {
          var_value_evaluator: dynamicVariableValue,
        },
      });
      if (response.status === 200) {
        await dispatch(setSavingState(false));
        return response?.data;
      }
    } catch (err) {
      dispatch(updateLoadError({ error_message: err.response.data.message }));
    }
  }
);

export const deleteDynamicVariable = createAsyncThunk(
  "deleteDynamicVariable",
  async ({ dynamicVariableId }, { dispatch, rejectWithValue }) => {
    await dispatch(setSavingState(true));
    try {
      const response = await apiAgent({
        method: "DELETE",
        url: `/api/v1/dynamic_variables/${dynamicVariableId}`,
      });
      if (response.status === 200) {
        await dispatch(setSavingState(false));
        return response?.data;
      }
    } catch (err) {
      dispatch(updateLoadError({ error_message: err.response.data.message }));
    }
  }
);

export const getAllDynamicVariables = createAsyncThunk(
  "getAllDynamicVariables",
  async ({ resourceId, resourceType }, { dispatch, rejectWithValue }) => {
    await dispatch(setLoadingState(true));
    try {
      const response = await apiAgent({
        method: "GET",
        url: `/api/v1/dynamic_variables`,
        params: {
          resource_id: resourceId,
          resource_type: resourceType,
        },
      });
      if (response.status === 200) {
        await dispatch(setLoadingState(false));
        return response?.data;
      }
    } catch (err) {
      dispatch(updateLoadError({ error_message: err.response.data.message }));
      await dispatch(setLoadingState(false));
    }
  }
);
